import httpClient, { isHttpError } from '../httpClient';

export async function getPlanoAcaoTed(id: string) {
  try {
    const response = await httpClient.get(`/api/ted-plano-acao/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter registro: ' + error);
  }
}

export async function getAllPlanosAcaoTed() {
  try {
    const response = await httpClient.get(`/api/ted-plano-acao`);

    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de registros: ' + error);
  }
}

export async function getPlanosAcaoPorTed(id: string) {
  try {
    const response = await httpClient.get(`/api/ted-plano-acao/ted/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter dados da Incorporação no SUS: ' + error);
  }
}
//==========

export async function createPlanoAcao(PlanoData: any) {
  try {
    const response = await httpClient.post(`/api/ted-plano-acao`, PlanoData);
    return response;
  } catch (error) {
    if (isHttpError(error)) {
      throw new Error(
        error.response?.data?.message || 'Erro ao salvar o plano de acão.',
      );
    }
    throw error;
  }
}

export const updatePlanoAcao = async (id: string, data: any): Promise<any> => {
  try {
    const response = await httpClient.patch(`/api/ted-plano-acao/${id}`, data);
    return response;
  } catch (error) {
    if (isHttpError(error)) {
      throw new Error(
        error.response?.data?.message || 'Erro ao atualizar o plano de acão.',
      );
    }
    throw error;
  }
};

export const deleteDeletePlanoAcao = async (id: string): Promise<any> => {
  try {
    const response = await httpClient.delete(`/api/ted-plano-acao/${id}`);
    return response;
  } catch (error) {
    if (isHttpError(error)) {
      throw new Error(
        error.response?.data?.message || 'Erro ao deletar o plano de acão.',
      );
    }
    throw error;
  }
};
